import { render, staticRenderFns } from "./InputMealCategoryCard.vue?vue&type=template&id=14766100&scoped=true"
import script from "./InputMealCategoryCard.vue?vue&type=script&lang=js"
export * from "./InputMealCategoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14766100",
  null
  
)

export default component.exports